import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		background: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			maxWidth: '100%',
			overflow: 'hidden',
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			'&:after': {
				content: '""',
				backgroundColor: 'black',
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: ({ metaData }) => metaData.mobileOpacity?.toNumber() / 100,
			},
		},
		image: ({ metaData: { mobileImagePosition } }) => ({
			marginBottom: mobileImagePosition.isLeftAlignment ? theme.spacing(3.5) : 0,
			marginTop: mobileImagePosition.isRightAlignment ? theme.spacing(3.5) : 0,

			'& picture': {
				display: 'flex',
				maxHeight: theme.spacing(47.5),
			},
			'& img': {
				width: '100%',
				objectPosition: ({ metaData }) => {
					const alignment = metaData.mobileAlignment?.metaValue

					return alignment ? `${alignment} !important` : null
				},
				objectFit: 'contain',
			},
			[theme.breakpoints.up('md')]: {
				marginBottom: 0,
				marginTop: 0,
				height: '100%',
				'& picture': {
					maxHeight: '100%',
					height: '100%',
				},
				'& img': {
					height: '100%',
					objectPosition: 'center',
				},
			},
		}),
		title: {
			marginBottom: theme.spacing(2.5),

			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) => {
						const alignment = metaData.mobileAlignment?.metaValue

						return alignment ? `${alignment} !important` : null
					},
				},
			},
		},
		description: {
			marginBottom: theme.spacing(4),

			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) => {
						const alignment = metaData.mobileAlignment?.metaValue

						return alignment ? `${alignment} !important` : null
					},
				},
			},
		},
	}),
	{ name: 'Category-Category4' },
)

export default useStyles
